import classes from "./Register.module.scss"
const Register = () => {
  return (<button className={classes.Register}>
    Записаться
  </button>);
}

export default Register;